import React, { useState } from "react";
import { useDrag } from "react-dnd";
import IconCollection from '../../IconCollection/IconCollection';
import { useSelector } from 'react-redux';
import SpinnerLoaderBlack from '../../Component/SpinnerLoaderBlack/SpinnerLoaderBlack';

const DraggableTeamTwoPlayer = ({ player, teamTwoColor, isLoadingTwo,setDraggedPlayerTeamTwo,targetedPlayerTeamTwo ,draggedPlayerTeamTwo}) => {
  // const teamTwoTargetPlayerList = useSelector(state => state?.playersReducer?.teamTwoTargetPlayerList);
  const isTargeted = targetedPlayerTeamTwo === player.jersey_number || draggedPlayerTeamTwo === player.jersey_number;
  const [{ isDragging }, drag] = useDrag({
    type: "teamTwoPlayer",
    item: { player },
    collect: (monitor) => {
      const isDragging = !!monitor.isDragging();

      return { isDragging };
    },
  });

  return (
    <div
      ref={isLoadingTwo ? null : drag}
      className={`sidePlayerContainer relative max-w-[54px] w-full h-[28px] lg:h-[60px] flex justify-center items-center font-bebas text-xl rounded text-light ${isLoadingTwo ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      style={{
        opacity: isLoadingTwo ? 0.5 : 1,
      }}
    >
    {
        player?.captain && (
          <div className="absolute top-[3px] lg:top-[2px] text-black right-[9px] lg:right-[20px] font-bebas text-[5px] lg:text-[8px] bg-white rounded-full lg:h-3 lg:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
            c
          </div>
        )
      }
       <p className="absolute left-0 top-[3px] lg:top-5 lg:text-[32px] text-[10px] text-white right-0 text-center">
        {player.jersey_number}
      </p>
      {isLoadingTwo && isTargeted && (
        <div className="absolute flex justify-center z-10 items-center left-0 top-0 bottom-0 right-0">
          <SpinnerLoaderBlack />
        </div>
      )}
      {/* Player Icon */}
      <IconCollection
        name="player-jersey-white-mini"
        svgFillColor={isLoadingTwo ? '#dad8d8c7 ' : teamTwoColor}
        customClass={`lg:max-w-[54px] max-w-[20px] lg:min-w-[54px] min-w-[20px] h-[27.34px] w-full lg:h-[69px]`}
      />
    </div>
  );
};

export default DraggableTeamTwoPlayer;
